import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';

import { HttpErrorResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class WhatsappForBusinessService {
  private env: any;
  private headers: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
    this.headers = this.helpersService.getNewApiHeaders();
  }

  getWhatsAppConfiguration(partnerID: number) {
    return this.http
      .get(
        this.env.url + `/WhatsAppForBusiness/Partner/${partnerID}/Configuration?code=` + this.env.key,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  completeWhatsAppOAuth(partnerID: number, code : string) {
    const data = {
      partnerID : partnerID,
      code: code
    }
    return this.http
      .post(
        this.env.url + `/WhatsAppForBusiness/Partner/OAuth?code=` + this.env.key, data,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  disconnectWhatsApp(partnerID: number) {
    
    return this.http
      .delete(
        this.env.url + `/WhatsAppForBusiness/Partner/${partnerID}/Disconnect?code=` + this.env.key,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  getWhatsAppPhoneNumbers(partnerID: number) {
    return this.http
      .get(
        this.env.url + `/WhatsAppForBusiness/Partner/${partnerID}/PhoneNumbers?code=` + this.env.key,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getWhatsAppInitiateChatTemplate(partnerID: number, platform: string) {
    return this.http
      .get(
        this.env.url + `/Stores/${partnerID}/Whatsapp/InitiateChatTemplate?Platform=${platform}&code=` + this.env.key,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  updateWhatsAppPhoneID(partnerID: number, phoneID : string, pin : string) {
    const data = {
      partnerID : partnerID,
      phoneID: phoneID,
      pin: pin
    }
    return this.http
      .post(
        this.env.url + `/WhatsAppForBusiness/Partner/PhoneNumber?code=` + this.env.key, data,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getWhatsAppMessageTemplates(partnerID: number) {
    return this.http
      .get(
        this.env.url + `/WhatsAppForBusiness/Partner/${partnerID}/MessageTemplates?code=` + this.env.key,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  sendWhatsAppMessage(partnerID: number, destinationNumber : string, text : string, templateID : string, languageCode: string) {
    const data = {
      partnerID : partnerID,
      destinationNumber: destinationNumber,
      text: text,
      templateID: templateID,
      languageCode: languageCode
    }
    return this.http
      .post(
        this.env.url + `/WhatsAppForBusiness/Partner/TestMessage?code=` + this.env.key, data,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  
  syncTemplatesToWhatsapp(partnerID: number) {
    const data = {
    }
    return this.http
      .post(
        this.env.url + `/WhatsAppForBusiness/Partner/${partnerID}/SyncMessageTemplates?code=` + this.env.key, data,
        this.headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

}
